import { render } from "./AccelAdmin.vue?vue&type=template&id=72cbe73b"
import script from "./AccelAdmin.vue?vue&type=script&lang=js"
export * from "./AccelAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__